import { Injectable } from "@angular/core";
import { Inject } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { DOCUMENT } from "@angular/common";
import { ProjectData } from "../_models/project-data";
import {
  BehaviorSubject,
  Observable,
  of,
  Subject,
  Subscription,
  throwError,
} from "rxjs";
// import { Http, Headers, Response, RequestOptions, RequestMethod } from '@angular/common/http';
import { environment } from "../../environments/environment";
@Injectable({
  providedIn: "root",
})
export class ProjectService {
  private subject = new Subject<any>();
  public subjectforProjectData = new Subject<any>();
  public subjectforTestSuite = new BehaviorSubject(null);
  private subjectforPaste = new Subject<any>();
  private subjectLoadLocator = new Subject<any>();
  private subjectforLocatorData = new Subject<any>();
  private subjectforLocatorDatafromTestStep = new Subject<any>();
  httpOptions: { headers: HttpHeaders };
  private subjectForupdateTestData = new Subject<any>();
  private subjectForTestCaseData = new Subject<any>();
  private projectDetails = new BehaviorSubject<any>(null);
  private userDetails = new BehaviorSubject<any>(null);
  private userTypes = new BehaviorSubject<any>(null);
  public treeView = new BehaviorSubject("project");
  private subjectForNewProject = new Subject<any>();
  private selectTestSuite = new Subject<any>();
  public isModuleSelected = new BehaviorSubject(false);
  public isLocatorModuleSelected = new BehaviorSubject(false);
  public selectedModuleData = new BehaviorSubject(null);
  public selectedLocatorModuleData = new BehaviorSubject(null);
  public isTestSuiteSelected = new BehaviorSubject(false);
  public isLocatorTestSuiteSelected = new BehaviorSubject(false);
  public loadSuggestion = new BehaviorSubject(false);
  public isLocatorViewActive  = new BehaviorSubject(false);
  subUrl: string;
  workflowurl: string;

  sendMessage(message: any) {
    this.subject.next({ text: message });
  }
setLocatorView(view){
  this.isLocatorViewActive.next(view);
}
  clearMessages() {
    this.subject.next(null);
  }
  shareProjectId(newProjectId) {
    this.subjectForNewProject.next(newProjectId);
  }
  getSharedProjectId() {
    return this.subjectForNewProject.asObservable();
  }
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

  sendCopyData(item, msg) {
    this.subjectforPaste.next({ item, msg });
  }

  getDataForPaste(): Observable<any> {
    return this.subjectforPaste.asObservable();
  }

  sendProjectData(projectData) {
    this.subjectforProjectData.next({ projectData });
  }

  getProjectData(): Observable<any> {
    return this.subjectforProjectData.asObservable();
  }

  setProjectDetails(projectData) {
    this.projectDetails.next(projectData);
  }
  setUserDetails(data){
    this.userDetails.next(data);
  }
  getUserDetails(){
    return this.userDetails.asObservable();
  }

  setUserType(data){
    this.userTypes.next(data);
  }
  getUserType(){
    return this.userTypes.asObservable();
  }
  getProjectDetails() {
    return this.projectDetails.asObservable();
  }

  sendLocatorData(Data) {
    this.subjectforLocatorData.next({ Data });
  }

  getLocatorData(): Observable<any> {
    return this.subjectforLocatorData.asObservable();
  }

  sendLocatorDataFromTestStep(Data) {
    this.subjectforLocatorDatafromTestStep.next({ Data });
  }

  getLocatorDataFromTestStep(): Observable<any> {
    return this.subjectforLocatorDatafromTestStep.asObservable();
  }

  sendTestSuiteData(Data) {
    this.selectTestSuite.next(Data);
  }

  getTestSuiteData(): Observable<any> {
    return this.selectTestSuite.asObservable();
  }

  sendUpdateData(data) {
    return this.subjectForupdateTestData.next({ data });
  }
  getUpdateData() {
    return this.subjectForupdateTestData.asObservable();
  }

  sendTestData(data) {
    return this.subjectForTestCaseData.next({ data });
  }
  getTestData() {
    return this.subjectForTestCaseData.asObservable();
  }
  private url: string;

  projectId: HttpParams;
  projectdataById: any;
  // getAllChildTestDir: any;
  locatorData: any;
  childTestData: any;

  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private router: Router,
    private cookieService: CookieService,

    @Inject(DOCUMENT) private document: Document
  ) {
    this.url = environment.baseUrl;
    this.subUrl = environment.url;
    this.workflowurl = environment.workflowUrl
  }

  public getAllProjects() {
    this.cookieService.get("loginData");
    return this.http.get<ProjectData[]>(
      this.url + "/HuLoopRest/huloop/" + "project"
    );
  }

  getProjectById(_projectId: any) {
    return this.http.get(
      this.url + "/HuLoopRest/huloop/" + "project/" + _projectId
    );
  }

  getProjectDetailsById(_projectId: any) {
    return this.http.get(
      this.url + "/HuLoopRest/huloop/" + "project/getProjectDetails/" + _projectId
    );
  }

  deleteProjectById(id) {
    return this.http.delete(this.url + "/HuLoopRest/huloop/" + "project/" + id);
  }

  deleteModule(projectId, moduleId)
  {
    return this.http.delete(this.url + "/HuLoopRest/huloop/test/" + projectId + "/" + moduleId);
  }

  // getAllChildTestDir(_projectId: any){

  // return this.http.get(this.url + '/HuLoopRest/huloop/'+ 'locator/all/' + _projectId).
  // subscribe(
  //   (data) => {
  //  this.childTestData = data[''];
  // });
  // }

  getAllChildLocatorDir(_projectId: any) {
    return this.http.get(
      this.url + "/HuLoopRest/huloop/" + "locator/all/" + _projectId
    );
  }

  //   getTestCaseData(projectId, testId){
  //  return this.http.get(this.url + '/HuLoopRest/huloop/'+'test/testCaseData/60fa6511e4b0c8c9b86173db/'+projectId+'/'+testId)}
  //  addDefaultProject( projectName, projectType)
  //  {
  //   return this.http.post(this.url + '/HuLoopRest/huloop/' + 'project', data)

  // }
  //http://beatblipdemo.agreeya.net/HuLoopRest/huloop/locator/addLocatorDirSuite
  addLocator(formObjValue) {
    return this.http.post(
      this.url + "/HuLoopRest/huloop/locator/addLocatorDirSuite",
      formObjValue
    );
  }

  addScreen(formObjValue) {
    return this.http.post(
      this.url + "/HuLoopRest/huloop/locator/addLocatorSuite",
      formObjValue
    );
  }
  addDefaultProject(formValue) {
    return this.http.post(this.url + "/HuLoopRest/huloop/project", formValue);
  }
  //http://beatblipdemo.agreeya.net/HuLoopRest/huloop/webRunSetting/

  loadRunSettings(projectId) {
    return this.http.get(
      this.url + "/HuLoopRest/huloop/webRunSetting/" + projectId
    );
  }

  createRunSettings(settingData) {
    return this.http.post(
      this.url + "/HuLoopRest/huloop/webRunSetting",
      settingData
    );
  }

  copyTestCase(projectId, parentId, testCaseId, options) {
    //console.log(projectId,parentId,testCaseId,options);
    // const headers = new HttpHeaders();
    // headers.append('Content-Type', 'application/json');
    // // let options = new RequestOptions({ headers: headers });
    return this.http.post(
      this.url +
        "/HuLoopRest/huloop/test/copyTestCase/" +
        projectId +
        "/" +
        parentId,
      testCaseId,
      options
    );
  }

  moveTestCase(projectId, parentId, testCaseId, testId) {
    // console.log(projectId,parentId,testCaseId,testId);
    // const headers = new HttpHeaders();
    // headers.append('Content-Type', 'application/json');
    // // let options = new RequestOptions({ headers: headers });
    return this.http.post(
      this.url +
        "/HuLoopRest/huloop/test/moveTestCase/" +
        projectId +
        "/" +
        parentId +
        "/" +
        testCaseId +
        "/" +
        testId,
      ""
    );
  }
  editProjectSetting(projectId, settingObj) {
    return this.http.put(
      this.url + "/HuLoopRest/huloop/project/editProjectSetting/" + projectId,
      settingObj
    );
  }

  loadLocator(id) {
    this.subjectLoadLocator.next(id);
  }
  getLocators() {
    return this.subjectLoadLocator.asObservable();
  }
  editLocatorDirSuiteTitle(objectForUpdate) {
    return this.http.post(
      this.url + "/HuLoopRest/huloop/locator/editLocatorDirSuiteTitle",
      objectForUpdate
    );
  }
  deleteLocator(projectId, locatorModuleId) {
    return this.http.delete(
      this.url +
        "/HuLoopRest/huloop/locator/deleteLocator/" +
        projectId +
        "/" +
        locatorModuleId
    );
  }

  addTestDir(module) {
    return this.http.post(
      this.url + "/HuLoopRest/huloop/test/addTestDir",
      module
    );
  }

  addTestSuite(suite) {
    return this.http.post(
      this.url + "/HuLoopRest/huloop/test/addTestFile",
      suite
    );
  }

  //http://beatblipdemo.agreeya.net/HuLoopRest/huloop/test/editTestDir

  editTestDir(objectForRename) {
    return this.http.post(
      this.url + "/HuLoopRest/huloop/test/editTestDir",
      objectForRename
    );
  }
  deleteTestSuite(projectId, suiteId) {
    return this.http.delete(
      this.url + "/HuLoopRest/huloop/test/" + projectId + "/" + suiteId
    );
  }

  getDefaultTextData(projectId) {
    return this.http.get(
      this.url + "/HuLoopRest/huloop/textData/" + projectId + "/default"
    );
  }

  importTestData(file, projectId, testDataId, testDataName) {
    var fd = new FormData();
    fd.append("file", file);

    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", "multipart/form-data");
    headers = headers.append("enctype", "multipart/form-data");

    return this.http.post(
      this.url +
        "/HuLoopRest/huloop/textData/upload/" +
        projectId +
        "/default/" +
        testDataId +
        "/" +
        testDataName,
      file,
      { headers }
    );
  }

  reloadLicense() {
    return this.http.get(
      this.url + "/HuLoopRest/huloop/licenseData/licenseList"
    );
  }

  getSettingData() {
    return this.http.get(
      this.url + "/HuLoopRest/huloop/licenseData/getSettingData"
    );
  }

  aboutBeatBlip() {
    return this.http.get(
      this.url + "/HuLoopRest/huloop/applicationResource/aboutus"
    );
  }
  getAzureProject(projectId) {
    return this.http.get(
      this.url + "/HuLoopRest/huloop/azure/projectList/" + projectId
    );
    //http://beatblipdemo.agreeya.net/HuLoopRest/huloop/azure/projectList/620f2f1660b2aacb6f65a20a
  }
  restoreSuite(projectId, suiteId, arrayData) {
    //http://beatblipdemo.agreeya.net/HuLoopRest/huloop/loggingResource/restoreSuite/61276c94a1f486a24017af5e/61a5e05568b4d67eb853c7fd
    return this.http.get(this.url + '/HuLoopRest/huloop/test/restoreFileData/' + projectId + '/' + suiteId);

  }
  getconsoleData(projectId) {
    return this.http.get(this.url + "/HuLoopRest/huloop/console/consoleAll/" +  projectId);
  }

  getConsoleRunData() {
    return this.http.get(this.url + "/HuLoopRest/huloop/test/consoleRunData");
  }

  addConsoleSetting(body) {
    return this.http.post(
      this.url + "/HuLoopRest/huloop/console/addConsoleSetting",
      body
    );
  }

  deleteSetting(id) {
    return this.http.delete(
      this.url + "/HuLoopRest/huloop/console/deleteSetting/" + id
    );
  }

  getSearchSuggestions() {
    return this.http.get(this.url + "/HuLoopRest/huloop/search/suggest");
  }

  searchProject(value: string) {
    return this.http.get(this.url + "/HuLoopRest/huloop/search/" + value);
  }

  importProject(value: any){
	let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'multipart/form-data');
    headers = headers.append('enctype', 'multipart/form-data')
	// return this.http.post(this.url + '/HuLoopRest/huloop/projectImport/import',value,{headers});
  return this.http.post(this.url + '/HuLoopRest/huloop/projectImport/upload',value,{headers});
}

uploadSelenium(projectId, testId, formData)
{
  return this.http.post(this.url+'/HuLoopRest/huloop/testImport/uploadSelenium/' + projectId + "/" + testId, formData);
}

uploadTestCase(projectId, suiteId, formData)
{
  return  this.http.post(this.url + "/HuLoopRest/huloop/testImport/uploadTestCase/" + projectId + "/" + suiteId, formData);
}

editLocatorSuitTitle(title){
  return this.http.post(this.url + '/HuLoopRest/huloop/locator/editLocatorSuiteTitle', title)
}

getProjectHierarchyCount()
{
  return this.http.get(this.url + "/HuLoopRest/huloop/project/heirarchy/counts");
}

getProjectExecutionCount(startDate, endDate)
{
  return this.http.get(this.url + "/HuLoopRest/huloop/testReport/allProjectTestDataDetailSummary/" + startDate  + "/" + endDate + "/ALL/ALL");
}

getGraphList()
{
  return this.http.get(this.url + '/HuLoopRest/huloop/test/graph/list');
}

getGraphOrder()
{
   return this.http.get(this.url + '/HuLoopRest/huloop/test/dashboard/order');
}

saveGraphOrder(body)
{
  return this.http.post(this.url + '/HuLoopRest/huloop/test/dashboard/order', body);
}

getSingleAutomationHierarchy(projectId)
{
  return this.http.get(this.url + '/HuLoopRest/huloop/project/resource/count/' + projectId);
}

getAutomationCountAcrossUsers()
{
  return this.http.get(this.url + '/HuLoopRest/huloop/access/automations/count');
} 

getRuntimeByAutomation(projectId, startDate, endDate)
{
  return this.http.get(this.url + "/HuLoopRest/huloop/testReport/runtime/period/" + projectId + '/' + startDate + '/' + endDate);
}

getAutomationRuntimeAcrossUsers(projectId, startDate, endDate)
{
  return this.http.get(this.url + "/HuLoopRest/huloop/testReport/runTime/" + projectId + '/' + startDate + '/' + endDate);
}


getRuntimeByOS(projectId, startDate, endDate)
{
  return this.http.get(this.url + "/HuLoopRest/huloop/testReport/runtime/os/" + projectId + '/' + startDate + '/' + endDate);
}

getRuntimeByUser(projectId, userName, startDate, endDate)
{
  return this.http.get(this.url + "/HuLoopRest/huloop/testReport/runtime/byuser/" + projectId + '/' + userName + '/' + startDate + '/' + endDate);
}

getAutomationVsModuleRuntime(projectId, moduleId, startDate, endDate)
{
  return this.http.get(this.url + "/HuLoopRest/huloop/testReport/duration/" + projectId + '/' + moduleId + '/' + startDate + '/' + endDate);
}

getUserList()
{
  return this.http.get(this.url + '/HuLoopRest/huloop/access/companyAccountUsers');
}

getCumulativeAutomationRuntime(projectId, startDate, endDate)
{
  return this.http.get(this.url + '/HuLoopRest/huloop/testReport/runtime/cumulative/' + projectId + '/' + startDate + '/' + endDate);
}

getSuiteRuntime(projectId, suiteId, startDate, endDate)
{
  return this.http.get(this.url + '/HuLoopRest/huloop/testReport/runtime/suite/' + projectId + '/' + suiteId + '/' + startDate + '/' + endDate)
}
restoreFiles(projectId,parentId?:string){
  //test/restoreFileData/{projectId}/{parentId}
  return this.http.get(this.url + '/HuLoopRest/huloop/test/restoreFileData/' + projectId + '/' + parentId);
}
getAllDeletedProjects(){
  return this.http.get(this.url + '/HuLoopRest/huloop/project/alldeleted');
}

createRC(obj)
{
  return this.http.post(this.url + '/HuLoopRest/huloop/component/create/new', obj);
}

deleteRc(componentId: string)
{
  return this.http.post(this.url + '/HuLoopRest/huloop/component/delete/' + componentId, '');
}

updateRC(obj)
{
  return this.http.post(this.url + '/HuLoopRest/huloop/component/create/new/', obj);
}

getRC()
{
  return this.http.get(this.url + '/HuLoopRest/huloop/component/get/component/group');
}
loadAccess(userId){
  //component/account/management/user/{userId}
  return this.http.get(this.url + '/HuLoopRest/huloop/component/account/management/user/'+ userId);
}

updateRcAccess(userId,body){
  //HuLoopRest/huloop/component/restriction/<userId>
  return this.http.post(this.url + '/HuLoopRest/huloop/component/restriction/'+ userId ,body);
}
sendRC(email,rcId)
{
  //HuLoopRest/huloop/component/share/<email_id>/<component_id>
  return this.http.post(this.url + '/HuLoopRest/huloop/component/share/'+ email + '/' + rcId,null);
}
//   importProject(name: string, value: any) {
//     let headers = new HttpHeaders();
//     headers = headers.append("Content-Type", "multipart/form-data");
//     headers = headers.append("enctype", "multipart/form-data");
//     return this.http.post(
//       this.url + "/HuLoopRest/huloop/projectImport/upload/" + name,
//       value,
//       { headers }
//     );
//   }
loadWorkflow(userId){
  //{{workflowurl}}/load/workflow/66d1b8c495787b50ac58a678
  return this.http.get(this.workflowurl + '/workflow/load/workflow/'+ userId);
}
updateWorkFlow(currentUserId,payload){
///user/restricted/
  return this.http.post(this.workflowurl + '/workflow/user/restricted/'+currentUserId, payload);
}
loadFeatureFlag(){

  return this.http.get(this.workflowurl + '/workflowFeatureFlag');
}
getWflist(userId?:any){
 
  return this.http.get(this.workflowurl + '/workflow/restricted/'+userId);

}
///workflow/load/workflow/6540c487a05526f37e525d39
getTempList(userId){
  return this.http.get(this.workflowurl + '/workflow/load/workflow/'+userId);
}
getPermissionWorkFlow(){
  ///permissions
  return this.http.get(this.workflowurl + '/workflow/permissions');
}

authenticateUser(userId){
  return this.http.post(this.workflowurl + '/user/'+userId,'');
}

updateConsoleDataByEmail(email, accessToken) {
  return this.http.post(this.url + "/HuLoopRest/huloop/console/updateConsoleDataByEmail/"+email, accessToken);
}

}
